import {useState} from 'react'
import {useQuery} from 'react-query'
import {fetchTripNotStartedReport} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import CRUDTable from '../../../components/table/CRUDTable'
import toast, {Toaster} from 'react-hot-toast'
import viewProps from '../viewProps'
import {Error500} from '../../modules/errors/components/Error500'
import TopBarProgress from 'react-topbar-progress-indicator'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import Select from 'react-select'
import {fetchShiftList} from '../shift/api'
import {fetchSubSchoolDetails} from '../profile/api'
import {TripNotStartedReportPayload} from './type'
import ExportToExcelButton from './ExportToExcelButton'
import useSchool from '../../hooks/useSchools'

const TripNotStartedReport = () => {
  const [filters, setFilters] = useState<TripNotStartedReportPayload>({
    trip_type: 'all',
    shift_id: 'all',
    sub_school_id: 'all',
    date:''
  })

  const {data: shift, isLoading: isLoadingShifts} = useQuery('shift', fetchShiftList)
  const {data: sub_school, isLoading: isLoadingsubschool} = useQuery('sub_school', fetchSubSchoolDetails)
  

  const {
    data: reportData,
    isLoading: isLoadingReport,
    isFetching,
    isError,
    refetch,
  } = useQuery(
    'trip-not-started-report',
    () =>
      fetchTripNotStartedReport({        
        trip_type: filters.trip_type ?? '',
        shift_id: filters.shift_id ?? '',
        date: filters.date?? '',
        sub_school_id:filters.sub_school_id
      }),
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  const { schoolName } = useSchool()

  const handleApplyFilters = () => {
    const {sub_school_id, shift_id, trip_type,date} = filters

    if (!sub_school_id && !shift_id && (!trip_type || trip_type === 'all') && !date) {
      toast.error('Please select all filter: sub_school_id, date, Shift, or Trip Type.')
      return
    }

    toast.loading('Applying filters...')
    refetch()
      .then(() => {
        toast.dismiss()
        toast.success('Filters applied successfully.')
      })
      .catch(() => {
        toast.dismiss()
        toast.error('Failed to Trip Not Started  report.')
      })
  }

  if (isLoadingShifts || isLoadingsubschool ) {
    return <Processing />
  }

  const shiftOptions = [{shift_name: 'all', shift_id: 'all'}, ...shift?.data!].map((item: any) => ({
    label: item.shift_name.toUpperCase(),
    value: item.shift_id,
  }))

  const selectedShiftName =
    shift?.data.find((opt: any) => opt.shift_id === filters.shift_id)?.shift_name || 'All Shifts'

  console.log(reportData?.data)
  const subschoolOptions = [{sub_school_id: 'all',sub_school_name:"all"}, ...sub_school?.data!].map((item: any) => ({
    ...item,
    label: item.sub_school_name.toUpperCase(),
    value: item.sub_school_id,
  }))
  const selectedTripType =
    filters.trip_type === 'all'
      ? 'All Trip Types'
      : filters.trip_type.charAt(0).toUpperCase() + filters.trip_type.slice(1)

  return (
    <>
      <Helmet>
        <title>TrackNAB | Trip Not Started Report</title>
      </Helmet>
      <PageTitle>Trip Not Started Report</PageTitle>

      {/* Filters Section */}
      <div className="mb-4 p-4 border rounded shadow-sm bg-light">
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.date}
              onChange={(e) => setFilters({...filters, date: e.target.value})}
            />
          </div>
          <div className="col-md-2">
            <label className="form-label">Trip Type</label>
            <select
              className="form-select"
              value={filters.trip_type}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  trip_type: e.target.value as 'all' | 'pickup' | 'drop',
                })
              }
            >
              <option value="all">ALL</option>
              <option value="pickup">Pickup</option>
              <option value="drop">Drop</option>
            </select>
          </div>
          
          <div className="col-md-3">
            <label className="form-label">Shift</label>
            <Select
              options={shiftOptions}
              onChange={(opt: any) => setFilters({...filters, shift_id: opt?.value || null})}
              value={shiftOptions.find((opt) => opt.value === filters.shift_id) || null}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Sub School Name</label>
            <Select
              options={subschoolOptions}
              onChange={(opt: any) => setFilters({...filters, sub_school_id: opt?.value || null})}
              value={subschoolOptions.find((opt) => opt.value === filters.sub_school_id) || null}
            />
          </div>
          <div className="col-md-12 d-flex justify-content-end">
            <button className="btn btn-primary mt-2" onClick={handleApplyFilters}>
              Apply Filters
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      {isLoadingReport && <Processing />}
      {isError && <Error500 />}
      {reportData?.data?.length! > 0 ? (
        <CRUDTable
          data={reportData?.data}
          {...viewProps.TripNotStartedReport}
          fieldToLabelMap={viewProps.TripNotStartedReport.primaryFieldsToLabelMap}
          headerExtras={
            <>
              {/* <div className="fs-3">{`Mes School Security Trip Not Started Report - ${selectedShiftName} - ${selectedTripType} - Year`}</div> */}
              <div className="ms-auto">
                <ExportToExcelButton
                  data={reportData?.data || []}
                  fileName="Trip Not Started Report"
                  heading={`${schoolName} Trip Not Started Report - ${selectedShiftName} - ${selectedTripType} - ${new Date().getFullYear()}`}
                  titleMap={viewProps.TripNotStartedReport.primaryFieldsToLabelMap}
                />
              </div>
            </>
          }
        />
      ) : (
        <div className="fs-2 p-6 text-center">Apply filters / No data for applied filters</div>
      )}

      {isFetching && <TopBarProgress />}
      <Toaster />
    </>
  )
}

export default TripNotStartedReport
